import { render, staticRenderFns } from "./MainContentExtra.vue?vue&type=template&id=4b2cc454&scoped=true"
import script from "./MainContentExtra.vue?vue&type=script&lang=js"
export * from "./MainContentExtra.vue?vue&type=script&lang=js"
import style0 from "./MainContentExtra.vue?vue&type=style&index=0&id=4b2cc454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cc454",
  null
  
)

export default component.exports